<div class="warning-wrapper">
  <mat-card appearance="outlined" class="section center-text">
    @if (loading) {
      <div class="loading">
        <mat-progress-spinner [diameter]="64" [strokeWidth]="2" mode="indeterminate"></mat-progress-spinner>
      </div>
    }
    @if (!loading) {
      <div>
        <mat-icon class="warning-icon">warning</mat-icon>
        @if (isPaused) {
          <h1>
            <b>{{ "accountExpired.headingPaused" | translate }}</b>
          </h1>
          <p [innerHTML]="'accountExpired.subheadingPaused' | translate"></p>
        } @else {
          <h1>
            <b>
              {{
                (isSelfServiceCustomer && !isSelfServiceTrial
                  ? "accountExpired.headingSelfService"
                  : isSelfServiceCustomer && isSelfServiceTrial
                    ? "accountExpired.headingSelfServiceTrial"
                    : "accountExpired.heading"
                ) | translate
              }}
            </b>
          </h1>
          <p>
            {{
              (isSelfServiceCustomer && !isSelfServiceTrial
                ? "accountExpired.subheadingSelfService"
                : isSelfServiceCustomer && isSelfServiceTrial
                  ? "accountExpired.subheadingSelfServiceTrial"
                  : "accountExpired.subheadingRegular1"
              ) | translate
            }}
          </p>
          @if (!isSelfServiceCustomer) {
            <p [innerHTML]="'accountExpired.subheadingRegular2' | translate"></p>
          }
          @if (isSelfServiceCustomer) {
            <button mat-flat-button class="primary-button" (click)="openPlanAndBilling()">
              <mat-icon>open_in_new</mat-icon>
              <span>{{ "accountExpired.plan-billing" | translate }}</span>
            </button>
          }
        }
        @if (canViewAccountAnyway) {
          <div class="admin-unlock">
            <button mat-stroked-button class="secondary-button" (click)="viewAccountAnyway()">
              <mat-icon>visibility</mat-icon>
              <span>{{ "accountExpired.admin-view-anyway" | translate }}</span>
            </button>
            <p class="admin-unlock-hint">{{ "accountExpired.admin-view-anyway-hint" | translate }}</p>
          </div>
        }
      </div>
    }
  </mat-card>
</div>
